/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { UserShort } from '../models/api/users';

export const getUsersList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<UserShort[]>('/user/list');
    return data;
};

export const getOperatorsUserList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<UserShort[]>('/user/operators');
    return data;
};
